const CalendarIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    style={{marginRight:10}}
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83398 9.16602H7.50065V10.8327H5.83398V9.16602ZM5.83398 12.5H7.50065V14.1667H5.83398V12.5ZM9.16748 9.16602H10.8341V10.8327H9.16748V9.16602ZM9.16748 12.5H10.8341V14.1667H9.16748V12.5ZM12.5005 9.16602H14.1672V10.8327H12.5005V9.16602ZM12.5005 12.5H14.1672V14.1667H12.5005V12.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16667 18.3327H15.8333C16.7525 18.3327 17.5 17.5852 17.5 16.666V6.66602V4.99935C17.5 4.08018 16.7525 3.33268 15.8333 3.33268H14.1667V1.66602H12.5V3.33268H7.5V1.66602H5.83333V3.33268H4.16667C3.2475 3.33268 2.5 4.08018 2.5 4.99935V6.66602V16.666C2.5 17.5852 3.2475 18.3327 4.16667 18.3327ZM15.8332 6.66602L15.834 16.666H4.1665V6.66602H15.8332Z"
      fill="currentColor"
    />
  </svg>
);

export default CalendarIcon;
